import React, { Component } from 'react';
import { LoginLayout } from '../../layouts';
import LoginLeftSide from '../../themes/shared/left-side/LoginLeftSide';
import { get } from 'lodash';
import { WithBackendConfig } from '../../providers/BackendConfigProvider/BackendConfigProvider';
import PropTypes from 'prop-types';

export class Login extends Component {
  static propTypes = {
    product: PropTypes.string.isRequired,
    redirectTo: PropTypes.func.isRequired,
    backendConfig: PropTypes.object.isRequired,
  };

  render() {
    const isAppOpticsUiHidden = get(this.props.backendConfig, 'featureFlags.aoHideAppopticsUi');
    if (this.props.product === 'appoptics' && Boolean(isAppOpticsUiHidden)) {
      return this.props.redirectTo('https://www.solarwinds.com/solarwinds-observability/registration');
    } else {
      return (
        <div data-test-page-name="login">
          <LoginLayout LeftSidePanel={LoginLeftSide} />
        </div>
      );
    }
  }
}

export default WithBackendConfig(Login);
